import MobileHomeBanner from './MobileHomeBanner';

export default MobileHomeBanner;
